/* ==========================================================================
   Taurine — interactions for the taurine-* sections.
   Vanilla JS, no dependencies. Re-inits on Theme Editor section load.
   Pack selection updates the NATIVE product form's hidden variant input, so
   add-to-cart posts to the real cart via Horizon's <product-form-component>.
   ========================================================================== */
(function () {
  'use strict';

  // Guard against double execution if the asset is included more than once.
  if (window.__taurineLoaded) return;
  window.__taurineLoaded = true;

  var TR = window.__taurine || (window.__taurine = {});

  /* ---------------------------------------------------------------------- */
  /* Start at top on load — prevent the page from auto-scrolling/jumping.     */
  /* Something in the theme grabs focus / scrolls after load, so we force the  */
  /* viewport back to the top across the whole load sequence (only when there  */
  /* is no #anchor in the URL, so real anchor links still work).              */
  /* ---------------------------------------------------------------------- */
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
  function forceTop() {
    if (window.location.hash) return;
    var a = document.activeElement;
    if (a && a !== document.body && typeof a.blur === 'function') { try { a.blur(); } catch (e) {} }
    window.scrollTo(0, 0);
  }
  /* ---------------------------------------------------------------------- */
  /* Neutralize Shopify's owner-only preview bar (a fixed ~1560px iframe that */
  /* inflates the mobile layout → pinch-out). Its src is set via JS, not an   */
  /* attribute, so CSS [src] can miss it — find it by the .src property.       */
  /* ---------------------------------------------------------------------- */
  function neutralizePreviewBar() {
    var vw = document.documentElement.clientWidth || window.innerWidth || 0;
    // enforce no-horizontal-overflow at the root, in case CSS got cached/overridden
    try {
      document.documentElement.style.setProperty('overflow-x', 'hidden', 'important');
      if (document.body) document.body.style.setProperty('overflow-x', 'hidden', 'important');
    } catch (e) {}
    var frames = document.getElementsByTagName('iframe');
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i];
      var src = f.src || f.getAttribute('src') || '';
      var isPreview = src.indexOf('preview-bar') > -1 || src.indexOf('shopifycloud') > -1;
      // also catch ANY iframe wider than the viewport that isn't inside our sections
      var wide = vw && f.getBoundingClientRect().width > vw + 2;
      if (f.closest && f.closest('.tr')) continue;   // never touch our own iframes
      if (!isPreview && !wide) continue;
      f.style.setProperty('display', 'none', 'important');
      // constrain every ancestor up to <body> so a wide wrapper can't inflate the page
      var p = f.parentElement, depth = 0;
      while (p && p !== document.body && depth < 8) {
        p.style.setProperty('max-width', '100vw', 'important');
        p.style.setProperty('overflow', 'hidden', 'important');
        if (getComputedStyle(p).position === 'fixed') {
          p.style.setProperty('inset-inline-start', '0', 'important');
          p.style.setProperty('inset-inline-end', '0', 'important');
        }
        p = p.parentElement; depth++;
      }
    }
  }
  /* ---------------------------------------------------------------------- */
  /* Catch-all: find and clamp ANY element that makes the page wider than    */
  /* the viewport (pinch-out), whatever it is — while leaving real           */
  /* horizontal scrollers (marquee, reviews, table) alone.                   */
  /* ---------------------------------------------------------------------- */
  function isScroller(cs) {
    return cs.overflowX === 'auto' || cs.overflowX === 'scroll' || cs.overflowX === 'hidden' ||
      cs.overflowX === 'clip' || (cs.contain && cs.contain.indexOf('paint') > -1);
  }
  function deOverflow() {
    var de = document.documentElement;
    de.style.setProperty('overflow-x', 'hidden', 'important');
    var b = document.body; if (!b) return;
    b.style.setProperty('overflow-x', 'hidden', 'important');
    b.style.setProperty('max-width', '100vw', 'important');
    var vw = de.clientWidth || window.innerWidth;
    if (!vw) return;
    var els = b.getElementsByTagName('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.hasAttribute && el.hasAttribute('data-tr-clamped')) continue;
      var r = el.getBoundingClientRect();
      if (r.width <= vw + 2) continue;                 // not wider than the screen
      if (r.right <= vw + 2 && r.left >= -2) continue;  // doesn't actually stick out
      var cs = getComputedStyle(el);
      if (isScroller(cs)) continue;                     // it's a scroll container — leave it
      // contained by a clipping ancestor? then it isn't the culprit
      var a = el.parentElement, contained = false;
      while (a && a !== b) { if (isScroller(getComputedStyle(a))) { contained = true; break; } a = a.parentElement; }
      if (contained) continue;
      el.style.setProperty('max-width', '100vw', 'important');
      el.style.setProperty('overflow-x', 'hidden', 'important');
      el.setAttribute('data-tr-clamped', '1');
    }
  }

  function fixWidth() { neutralizePreviewBar(); deOverflow(); }
  fixWidth();
  ['DOMContentLoaded', 'load'].forEach(function (ev) { window.addEventListener(ev, fixWidth); });
  [200, 600, 1200, 2500, 4000].forEach(function (t) { setTimeout(fixWidth, t); });
  window.addEventListener('resize', deOverflow);
  window.addEventListener('orientationchange', function () { setTimeout(fixWidth, 200); });
  if ('MutationObserver' in window) {
    document.addEventListener('DOMContentLoaded', function () {
      // childList only (not subtree) — catches top-level widgets/pixels apps inject,
      // without firing on every small DOM change.
      if (document.body) new MutationObserver(fixWidth).observe(document.body, { childList: true });
    });
  }

  forceTop();
  document.addEventListener('DOMContentLoaded', forceTop);
  document.addEventListener('DOMContentLoaded', neutralizePreviewBar);
  window.addEventListener('load', function () {
    forceTop();
    requestAnimationFrame(forceTop);
    setTimeout(forceTop, 60);
    setTimeout(forceTop, 250);
    setTimeout(forceTop, 600);
  });

  /* ---------------------------------------------------------------------- */
  /* Reveal on scroll                                                        */
  /* ---------------------------------------------------------------------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.tr-reveal:not([data-tr-observed])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { el.setAttribute('data-tr-observed', '1'); io.observe(el); });
  }

  /* ---------------------------------------------------------------------- */
  /* Countdown (rolling timer). NOTE: a resetting timer is a demo/urgency    */
  /* device — before launch, tie it to a real promo end date to comply with  */
  /* Israeli consumer-protection rules (no permanent fake "sale").           */
  /* ---------------------------------------------------------------------- */
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-tr-countdown]:not([data-tr-running])').forEach(function (el) {
      el.setAttribute('data-tr-running', '1');
      var hours = parseInt(el.getAttribute('data-tr-countdown'), 10) || 6;
      var t = hours * 3600 - 1;
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        if (t < 0) t = hours * 3600;
        el.textContent = pad(Math.floor(t / 3600)) + ':' + pad(Math.floor((t % 3600) / 60)) + ':' + pad(t % 60);
        t--;
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Ship-today cutoff countdown (e.g. order within HH:MM:SS to ship today)   */
  /* ---------------------------------------------------------------------- */
  function initCutoff(root) {
    (root || document).querySelectorAll('[data-tr-cutoff]:not([data-tr-running])').forEach(function (el) {
      el.setAttribute('data-tr-running', '1');
      var parts = (el.getAttribute('data-tr-cutoff') || '17:00').split(':');
      var ch = parseInt(parts[0], 10); var cm = parseInt(parts[1], 10) || 0;
      if (isNaN(ch)) return;
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var now = new Date();
        var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), ch, cm, 0, 0);
        if (target <= now) target.setDate(target.getDate() + 1); // past cutoff → next day
        var s = Math.max(0, Math.floor((target - now) / 1000));
        el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Gallery — thumbnail swaps main image (with crossfade)                   */
  /* ---------------------------------------------------------------------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-tr-gallery]:not([data-tr-init])').forEach(function (gal) {
      gal.setAttribute('data-tr-init', '1');
      var track = gal.querySelector('[data-tr-gal-track]');
      if (!track) return;
      var slides = track.children;
      var thumbs = gal.querySelectorAll('[data-tr-thumb]');
      var dotsWrap = gal.querySelector('[data-tr-gal-dots]');

      function go(i) { if (slides[i]) slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }

      // build one dot per slide (mobile indicator, generated so image content stays the only editable part)
      var dots = [];
      if (dotsWrap && slides.length > 1) {
        for (var i = 0; i < slides.length; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'd' + (i === 0 ? ' on' : '');
          b.setAttribute('aria-label', 'תמונה ' + (i + 1));
          b.addEventListener('click', (function (idx) { return function () { go(idx); }; })(i));
          dotsWrap.appendChild(b); dots.push(b);
        }
      }

      // mobile-only "1 / 6" counter — makes it obvious there are more images
      var counter = null;
      if (dotsWrap && slides.length > 1) {
        counter = document.createElement('div');
        counter.className = 'tr-gal-count'; counter.setAttribute('aria-hidden', 'true');
        counter.textContent = '1 / ' + slides.length;
        dotsWrap.parentNode.appendChild(counter);
      }

      function setActive(idx) {
        if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
        for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.toggle('active', t === idx);
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('on', d === idx);
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { go(i); setActive(i); });
      });

      // one-time swipe hint: first time the gallery is on screen, the next image peeks in and back
      if (slides.length > 1 && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var io = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return;
          io.disconnect();
          setTimeout(function () {
            if (track.scrollLeft !== 0) return;   // user already swiped
            track.classList.add('tr-nudge');
            track.addEventListener('animationend', function () { track.classList.remove('tr-nudge'); }, { once: true });
          }, 700);
        }, { threshold: 0.6 });
        io.observe(track);
      }

      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var max = track.scrollWidth - track.clientWidth;
          var ratio = max > 0 ? Math.abs(track.scrollLeft) / max : 0;   // abs() → RTL-safe
          setActive(Math.round(ratio * (slides.length - 1)));
        });
      }, { passive: true });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Before / After video stories — tab switch + autoplay-in-view + hover    */
  /* ---------------------------------------------------------------------- */
  function initBeforeAfter(root) {
    (root || document).querySelectorAll('[data-tr-ba]:not([data-tr-init])').forEach(function (ba) {
      ba.setAttribute('data-tr-init', '1');
      var tabs = Array.prototype.slice.call(ba.querySelectorAll('[data-tr-ba-tab]'));
      var stories = Array.prototype.slice.call(ba.querySelectorAll('[data-tr-ba-story]'));
      var inView = false;

      function playStory(story) {
        if (!story) return;
        story.querySelectorAll('[data-tr-ba-video]').forEach(function (v) {
          if (inView && !v.dataset.hoverPaused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      }
      function pauseAll() {
        ba.querySelectorAll('[data-tr-ba-video]').forEach(function (v) { v.pause(); });
      }
      function activeStory() { return stories.filter(function (s) { return s.classList.contains('active'); })[0]; }

      function activate(idx, focusTab) {
        tabs.forEach(function (t, i) {
          var on = i === idx;
          t.classList.toggle('on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');   // roving tabindex
        });
        stories.forEach(function (s, i) {
          var on = i === idx;
          s.classList.toggle('active', on);
          if (on) { s.removeAttribute('hidden'); } else { s.setAttribute('hidden', ''); }
        });
        pauseAll();
        playStory(stories[idx]);
        if (focusTab && tabs[idx]) tabs[idx].focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(i); });
        // RTL tablist: Left = next, Right = previous (spec 7.4)
        tab.addEventListener('keydown', function (e) {
          var last = tabs.length - 1;
          switch (e.key) {
            case 'ArrowLeft':
            case 'ArrowDown':
              e.preventDefault(); activate(i === last ? 0 : i + 1, true); break;
            case 'ArrowRight':
            case 'ArrowUp':
              e.preventDefault(); activate(i === 0 ? last : i - 1, true); break;
            case 'Home':
              e.preventDefault(); activate(0, true); break;
            case 'End':
              e.preventDefault(); activate(last, true); break;
          }
        });
      });

      // pause on hover (per spec), resume on leave
      ba.querySelectorAll('[data-tr-ba-video]').forEach(function (v) {
        v.addEventListener('mouseenter', function () { v.dataset.hoverPaused = '1'; v.pause(); });
        v.addEventListener('mouseleave', function () { delete v.dataset.hoverPaused; if (inView) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
      });

      // autoplay only while the section is in the viewport
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            inView = e.isIntersecting;
            if (inView) playStory(activeStory()); else pauseAll();
          });
        }, { threshold: 0.25 }).observe(ba);
      } else {
        inView = true; playStory(activeStory());
      }
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Reviews carousel dots                                                   */
  /* ---------------------------------------------------------------------- */
  function initReviews(root) {
    (root || document).querySelectorAll('[data-tr-reviews]:not([data-tr-init])').forEach(function (wrap) {
      wrap.setAttribute('data-tr-init', '1');
      var track = wrap.querySelector('[data-tr-rev-track]');
      var dots = wrap.querySelectorAll('[data-tr-rev-dot]');
      if (!track) return;
      function setActiveDot(idx) {
        dots.forEach(function (d, i) {
          var on = i === idx;
          d.classList.toggle('on', on);
          if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
      track.addEventListener('scroll', function () {
        var max = track.scrollWidth - track.clientWidth;
        var ratio = max > 0 ? Math.abs(track.scrollLeft) / max : 0;   // abs() → RTL-safe
        var idx = Math.round(ratio * (dots.length - 1));
        setActiveDot(idx);
      }, { passive: true });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var cards = track.children;
          if (cards[i]) cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });

      // prev/next buttons — scroll by one card. RTL: "next" advances toward the
      // later cards, which sit to the LEFT (negative delta).
      function cardStep() {
        var first = track.children[0];
        return first ? first.getBoundingClientRect().width + 18 : track.clientWidth * 0.85;
      }
      var prevBtn = wrap.querySelector('[data-tr-rev-prev]');
      var nextBtn = wrap.querySelector('[data-tr-rev-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });

      // gentle auto-scroll — DESKTOP ONLY. On touch devices we never run the
      // interval: it fought the browser's native momentum/snap and caused the
      // stutter on mobile swipe. Native touch scroll + snap is enough there.
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isTouch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (track.hasAttribute('data-tr-autoscroll') && !reduce && !isTouch) {
        var paused = false, userPaused = false, dir = 1;
        ['mouseenter', 'touchstart', 'pointerdown', 'focusin'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }, { passive: true }); });
        ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) { track.addEventListener(ev, function () { paused = false; }, { passive: true }); });
        // explicit pause/play control (WCAG 2.2.2)
        var pauseBtn = wrap.querySelector('[data-tr-rev-pause]');
        if (pauseBtn) {
          pauseBtn.addEventListener('click', function () {
            userPaused = !userPaused;
            pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
            pauseBtn.setAttribute('aria-label', userPaused ? 'הפעל גלילה אוטומטית' : 'השהה גלילה אוטומטית');
            var ip = pauseBtn.querySelector('.ic-pause'); var ipl = pauseBtn.querySelector('.ic-play');
            if (ip) ip.style.display = userPaused ? 'none' : 'block';
            if (ipl) ipl.style.display = userPaused ? 'block' : 'none';
          });
        }
        setInterval(function () {
          if (paused || userPaused || track.scrollWidth - track.clientWidth <= 0) return;
          var before = track.scrollLeft;
          track.scrollLeft = before + dir;
          if (track.scrollLeft === before) dir = -dir; // hit an edge → reverse
        }, 28);
      }
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Hero gallery parallax — the image drifts DOWN as the page scrolls and    */
  /* stops a little before the hero ends. Desktop only (mobile-first: the      */
  /* gallery stays static & stacked on top on small screens), and disabled     */
  /* under prefers-reduced-motion.                                             */
  /* ---------------------------------------------------------------------- */
  function initHeroParallax() {
    var hero = document.querySelector('.tr-hero');
    if (!hero || hero.hasAttribute('data-tr-parallax')) return;
    var gallery = hero.querySelector('.tr-gallery');
    if (!gallery) return;
    hero.setAttribute('data-tr-parallax', '1');
    var mqDesktop = window.matchMedia('(min-width: 1001px)');
    var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var maxOffset = 0, ticking = false;
    function measure() {
      // leave ~140px so the image halts before the hero's bottom edge
      maxOffset = Math.max(0, hero.offsetHeight - gallery.offsetHeight - 140);
    }
    function update() {
      ticking = false;
      if (!mqDesktop.matches || mqReduce.matches) { gallery.style.transform = ''; return; }
      var top = hero.getBoundingClientRect().top;   // < 0 once scrolled past the hero top
      var scrolled = top < 0 ? -top : 0;
      var offset = Math.min(scrolled * 0.6, maxOffset);
      gallery.style.transform = 'translate3d(0,' + offset + 'px,0)';
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    measure(); update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); update(); });
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', function () { measure(); update(); });
  }

  /* ---------------------------------------------------------------------- */
  /* Marquee pause/play (WCAG 2.2.2)                                          */
  /* ---------------------------------------------------------------------- */
  function initMarquee(root) {
    (root || document).querySelectorAll('[data-tr-marquee-pause]:not([data-tr-init])').forEach(function (btn) {
      btn.setAttribute('data-tr-init', '1');
      var marquee = btn.closest('[data-tr-marquee]');
      if (!marquee) return;
      btn.addEventListener('click', function () {
        var paused = marquee.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'הפעל גלילת טקסט' : 'השהה גלילת טקסט');
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Pack selector <-> native variant  (the conversion core)                 */
  /* ---------------------------------------------------------------------- */
  // The gifts panel starts CLOSED and is opened only by the customer (curiosity
  // hook — per client). This just keeps the header text in sync with the pack:
  // "unlocked" wording at 2+ tubs, "locked" wording at 1. It never force-opens.
  // Gifts are always OPEN & visible (per client). For a 1-tub pack they show a
  // dimmed "locked" state as an upgrade incentive; 2+ tubs = unlocked/free.
  function updateGifts(units) {
    document.querySelectorAll('[data-tr-gifts]').forEach(function (g) {
      var unlocked = units >= 2;
      g.classList.toggle('locked', !unlocked);
      var titleEl = g.querySelector('[data-tr-gifts-title]');
      if (titleEl) titleEl.textContent = unlocked ? (g.getAttribute('data-title-open') || '') : (g.getAttribute('data-title-locked') || '');
    });
  }

  function initGifts(root) {
    (root || document).querySelectorAll('[data-tr-gifts-toggle]:not([data-tr-init])').forEach(function (btn) {
      btn.setAttribute('data-tr-init', '1');
      btn.addEventListener('click', function () {
        var g = btn.closest('[data-tr-gifts]');
        if (!g) return;
        var open = g.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function updateSubCta(pack) {
    var supply = parseInt(pack.getAttribute('data-supply'), 10);
    var freeship = pack.getAttribute('data-freeship') === '1';
    var parts = [];
    if (freeship) parts.push('משלוח חינם');
    parts.push('אחריות 60 יום');
    if (supply) parts.push('מספיק ל-' + supply + ' יום');
    document.querySelectorAll('[data-tr-cta-sub]').forEach(function (el) { el.textContent = parts.join(' · '); });
  }

  function applyPack(pack) {
    var vId = pack.getAttribute('data-variant-id');
    var total = pack.getAttribute('data-total') || '';
    var compare = pack.getAttribute('data-compare') || '';
    var units = parseInt(pack.getAttribute('data-units'), 10) || 1;

    // 1) native product form hidden variant input
    var input = document.querySelector('[data-tr-variant-input]');
    if (input && vId) {
      input.value = vId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 2) ATC button total
    document.querySelectorAll('[data-tr-atc-total]').forEach(function (el) { el.textContent = total; });

    // 3) sticky bar
    document.querySelectorAll('[data-tr-sticky-price]').forEach(function (el) { el.textContent = total; });
    document.querySelectorAll('[data-tr-sticky-compare]').forEach(function (el) { el.textContent = compare; });

    // 4) gifts ladder + dynamic sub-CTA
    updateGifts(units);
    updateSubCta(pack);

    // 5) selected state + roving tabindex + aria-checked (WCAG 4.1.2)
    var group = pack.closest('[data-tr-packs]') || document;
    group.querySelectorAll('[data-tr-pack]').forEach(function (p) {
      p.classList.remove('sel');
      p.setAttribute('aria-checked', 'false');
      p.setAttribute('tabindex', '-1');
    });
    pack.classList.add('sel');
    pack.setAttribute('aria-checked', 'true');
    pack.setAttribute('tabindex', '0');
  }

  function initPacks(root) {
    (root || document).querySelectorAll('[data-tr-packs]:not([data-tr-init])').forEach(function (wrap) {
      wrap.setAttribute('data-tr-init', '1');
      var packs = Array.prototype.slice.call(wrap.querySelectorAll('[data-tr-pack]'));
      // RTL radiogroup: Left arrow = next, Right arrow = previous (spec 6.3)
      function move(from, dir) {
        var i = packs.indexOf(from);
        if (i < 0) return;
        var next = (i + dir + packs.length) % packs.length;
        var target = packs[next];
        applyPack(target);
        target.focus();
      }
      packs.forEach(function (pack) {
        pack.addEventListener('click', function () { applyPack(pack); });
        pack.addEventListener('keydown', function (e) {
          switch (e.key) {
            case 'Enter':
            case ' ':
              e.preventDefault(); applyPack(pack); break;
            case 'ArrowLeft':
            case 'ArrowDown':
              e.preventDefault(); move(pack, +1); break;   // next
            case 'ArrowRight':
            case 'ArrowUp':
              e.preventDefault(); move(pack, -1); break;   // previous
            case 'Home':
              e.preventDefault(); applyPack(packs[0]); packs[0].focus(); break;
            case 'End':
              e.preventDefault(); applyPack(packs[packs.length - 1]); packs[packs.length - 1].focus(); break;
          }
        });
      });
      // apply the pre-selected pack (or first)
      var initial = wrap.querySelector('[data-tr-pack].sel') || packs[0];
      if (initial) applyPack(initial);
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Sticky buy bar — goes straight to the checkout permalink                 */
  /* ---------------------------------------------------------------------- */
  function initStickyBuy(root) {
    (root || document).querySelectorAll('[data-tr-sticky-add]:not([data-tr-init])').forEach(function (btn) {
      btn.setAttribute('data-tr-init', '1');
      btn.addEventListener('click', function () { trGoToCheckout(); });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Count-up numbers (stats banner) — animate 0 → target when in view       */
  /* ---------------------------------------------------------------------- */
  function initCounters(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function fmt(n, decimals) {
      var s = decimals ? n.toFixed(decimals) : String(Math.round(n));
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    function run(el) {
      var target = parseFloat(String(el.getAttribute('data-target') || '0').replace(/,/g, '')) || 0;
      var decimals = (String(el.getAttribute('data-target')).split('.')[1] || '').length;
      if (reduce) { el.textContent = fmt(target, decimals); return; }
      var dur = 1400, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * eased, decimals);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var els = (root || document).querySelectorAll('[data-tr-count]:not([data-tr-done])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.setAttribute('data-tr-done', '1'); run(el); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.setAttribute('data-tr-done', '1'); run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------------- */
  /* Timeline — draw the line + fill nodes + slide steps in as they enter    */
  /* ---------------------------------------------------------------------- */
  function initTimeline(root) {
    (root || document).querySelectorAll('[data-tr-timeline]:not([data-tr-init])').forEach(function (tl) {
      tl.setAttribute('data-tr-init', '1');
      var steps = Array.prototype.slice.call(tl.querySelectorAll('[data-tl-step]'));
      var fill = tl.querySelector('[data-tl-fill]');
      if (!steps.length) return;
      var revealed = 0;
      function grow() { if (fill) fill.style.height = Math.round((revealed / steps.length) * 100) + '%'; }
      if (!('IntersectionObserver' in window)) {
        steps.forEach(function (s) { s.classList.add('in', 'on'); });
        revealed = steps.length; grow(); return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var idx = steps.indexOf(e.target);
          e.target.classList.add('in', 'on');
          if (idx + 1 > revealed) { revealed = idx + 1; grow(); }
          io.unobserve(e.target);
        });
      }, { threshold: 0.5, rootMargin: '0px 0px -10% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Flip cards — tap to flip (mobile), keyboard toggle; desktop uses :hover */
  /* ---------------------------------------------------------------------- */
  function initFlips(root) {
    (root || document).querySelectorAll('[data-tr-flip]:not([data-tr-init])').forEach(function (card) {
      card.setAttribute('data-tr-init', '1');
      var front = card.querySelector('[data-tr-flip-front]');
      var back = card.querySelector('[data-tr-flip-back]');
      function toggle() {
        var open = card.classList.toggle('flipped');
        card.setAttribute('aria-expanded', open ? 'true' : 'false');
        // 5.4: keep the hidden face out of the accessibility tree
        if (back) back.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (front) front.setAttribute('aria-hidden', open ? 'true' : 'false');
      }
      card.addEventListener('click', function (e) {
        // let the read-more link work without toggling back
        if (e.target.closest('a')) return;
        toggle();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Modals (comparison "why", and reused by exit-intent)                    */
  /* ---------------------------------------------------------------------- */
  var TR_openModal = null;
  var TR_lastFocus = null;
  function trFocusables(el) {
    return Array.prototype.slice.call(el.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (n) { return n.offsetWidth || n.offsetHeight || n.getClientRects().length; });
  }
  function trTrapKey(e) {
    if (!TR_openModal || e.key !== 'Tab') return;
    var f = trFocusables(TR_openModal);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openModal(modal) {
    if (!modal) return;
    // 8.3: remember where focus came from so we can return it on close
    TR_lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('tr-modal-open');
    requestAnimationFrame(function () { modal.classList.add('show'); });
    TR_openModal = modal;
    // 8.2/8.3: move focus into the dialog and trap Tab inside it
    var f = trFocusables(modal);
    var card = modal.querySelector('[role="dialog"]') || modal;
    requestAnimationFrame(function () { (f[0] || card).focus(); });
    document.addEventListener('keydown', trTrapKey, true);
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('show');
    document.body.classList.remove('tr-modal-open');
    setTimeout(function () { modal.hidden = true; }, 300);
    if (TR_openModal === modal) {
      TR_openModal = null;
      document.removeEventListener('keydown', trTrapKey, true);
    }
    // 8.4: return focus to the element that opened the modal
    if (TR_lastFocus && typeof TR_lastFocus.focus === 'function') {
      try { TR_lastFocus.focus(); } catch (e) {}
    }
    TR_lastFocus = null;
  }
  TR.openModal = openModal; TR.closeModal = closeModal;
  function initModals(root) {
    (root || document).querySelectorAll('[data-tr-modal-open]:not([data-tr-init])').forEach(function (btn) {
      btn.setAttribute('data-tr-init', '1');
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-tr-modal-open');
        openModal(document.querySelector('[data-tr-modal="' + id + '"]'));
      });
    });
    (root || document).querySelectorAll('[data-tr-modal-close]:not([data-tr-init])').forEach(function (el) {
      el.setAttribute('data-tr-init', '1');
      el.addEventListener('click', function () { closeModal(el.closest('[data-tr-modal]')); });
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && TR_openModal) closeModal(TR_openModal); });

  /* ---------------------------------------------------------------------- */
  /* Sticky bar reveal — show only after the hero CTA scrolls out of view    */
  /* ---------------------------------------------------------------------- */
  function initStickyReveal(root) {
    var bar = document.querySelector('.tr-sticky-buy');
    var anchor = document.querySelector('[data-tr-atc]') || document.querySelector('[data-tr-packs]');
    if (!bar || !anchor || bar.hasAttribute('data-tr-reveal-init')) return;
    bar.setAttribute('data-tr-reveal-init', '1');
    if (!('IntersectionObserver' in window)) { bar.classList.add('show'); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting); });
    }, { rootMargin: '0px 0px -40% 0px' }).observe(anchor);
  }

  /* ---------------------------------------------------------------------- */
  /* Scroll progress bar                                                     */
  /* ---------------------------------------------------------------------- */
  function initProgress() {
    var el = document.querySelector('[data-tr-progress] i');
    if (!el || el.__trInit) return;
    el.__trInit = true;
    function upd() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? Math.min(window.scrollY / h, 1) : 0;
      el.style.width = (p * 100) + '%';
    }
    upd();
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
  }

  /* ---------------------------------------------------------------------- */
  /* Idle popup — once per session, shows after 10s of no user activity     */
  /* ---------------------------------------------------------------------- */
  function initExit() {
    var modal = document.querySelector('[data-tr-exit]');
    if (!modal || modal.hasAttribute('data-tr-init')) return;
    modal.setAttribute('data-tr-init', '1');
    var KEY = 'tr_exit_shown';
    function seen() { try { return localStorage.getItem(KEY); } catch (e) { return false; } }
    function mark() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    if (seen()) return;
    var fired = false;
    function trigger() {
      if (fired || seen() || TR_openModal) return;
      fired = true; mark(); openModal(modal);
    }
    /* Fire after IDLE_MS with no touch / mouse / scroll / key activity.       */
    var IDLE_MS = 30000;
    var timer;
    function resetIdle() {
      if (fired) return;
      clearTimeout(timer);
      timer = setTimeout(trigger, IDLE_MS);
    }
    ['mousemove', 'mousedown', 'touchstart', 'touchmove', 'scroll', 'wheel', 'keydown'].forEach(function (ev) {
      document.addEventListener(ev, resetIdle, { passive: true });
    });
    resetIdle();
  }

  /* ---------------------------------------------------------------------- */
  /* Live-buy popup                                                          */
  /* ---------------------------------------------------------------------- */
  function initLiveBuy(root) {
    (root || document).querySelectorAll('[data-tr-live-buy]:not([data-tr-init])').forEach(function (el) {
      el.setAttribute('data-tr-init', '1');
      var data = [];
      try { data = JSON.parse(el.getAttribute('data-buyers') || '[]'); } catch (e) { data = []; }
      if (!data.length) return;
      var nameEl = el.querySelector('[data-tr-live-name]');
      var metaEl = el.querySelector('[data-tr-live-meta]');
      var closeEl = el.querySelector('[data-tr-live-close]');
      var i = 0, dismissed = false, hideT;
      if (closeEl) closeEl.addEventListener('click', function () { dismissed = true; el.classList.remove('show'); });
      function show() {
        if (dismissed) return;
        var b = data[i % data.length]; i++;
        if (nameEl) nameEl.textContent = b.name || '';
        if (metaEl) metaEl.textContent = b.meta || '';
        el.classList.add('show');
        clearTimeout(hideT);
        hideT = setTimeout(function () { el.classList.remove('show'); }, 5200);
      }
      setTimeout(function loop() { show(); setTimeout(loop, 16000); }, 6000);
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Cart count refresh (keep the custom nav badge in sync with native cart) */
  /* ---------------------------------------------------------------------- */
  function refreshCartCount() {
    var badges = document.querySelectorAll('[data-tr-cart-count]');
    if (!badges.length) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        badges.forEach(function (b) { b.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  /* ---------------------------------------------------------------------- */
  /* Secondary CTAs → add selected pack to cart, then straight to checkout    */
  /* (the pack-selector ATC button is NOT touched — it submits the form.)     */
  /* ---------------------------------------------------------------------- */
  function trSelectedVariantId() {
    // 1) whatever the pack selector last wrote to the hidden variant input
    var input = document.querySelector('[data-tr-variant-input]');
    if (input && input.value) return input.value;
    // 2) fallback → pack 2 (2 tubs, the "most popular" default), else first pack
    var pack = document.querySelector('[data-tr-pack][data-units="2"]') ||
               document.querySelector('[data-tr-pack]');
    return pack ? pack.getAttribute('data-variant-id') : null;
  }

  /* Direct checkout permalink — /cart/{variant}:{qty} replaces the cart with  */
  /* exactly this line and jumps to checkout, so nothing ever accumulates.     */
  function trCheckoutHref(id) {
    return '/cart/' + id + ':1?payment=shop_pay';
  }

  /* Add the selected pack to the cart and slide the cart drawer open (side panel),
     instead of jumping straight to checkout. Falls back to the /cart page if the
     drawer isn't available or the add fails. */
  function trAddAndOpenDrawer(id) {
    var drawer = document.querySelector('cart-drawer-component[data-tr-cart-drawer]') ||
                 document.querySelector('cart-drawer-component');
    var sections = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) sections.push(el.dataset.sectionId);
    });
    // Replace the cart with exactly the selected pack (funnel behaviour: one line,
    // clicking buy never accumulates — matches the original direct-checkout permalink).
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { throw new Error(data.description || 'add failed'); }
        // Let Horizon's cart components (items, summary, bubble) re-render.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { sections: data.sections } }
        }));
        refreshCartCount();
        // The cart re-render (morph) can re-render the dialog closed (and may replace
        // the element), racing our open. Re-query and re-open across a short window
        // until it sticks.
        var tries = 0;
        var opener = setInterval(function () {
          var dd = document.querySelector('cart-drawer-component[data-tr-cart-drawer]') ||
                   document.querySelector('cart-drawer-component');
          var dlg = dd && dd.querySelector('dialog');
          // Open the dialog directly — the component's open() can be flaky right after
          // a morph (refs not yet hydrated), while showModal() is reliable.
          if (dlg && !dlg.open && typeof dlg.showModal === 'function') {
            try { dlg.showModal(); } catch (e) {}
          }
          if (++tries >= 12) { clearInterval(opener); }
        }, 100);
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  function trGoToCheckout() {
    var id = trSelectedVariantId();
    if (!id) { window.location.href = '/cart'; return; }
    trAddAndOpenDrawer(id);
  }

  function initCheckoutCtas(root) {
    (root || document).querySelectorAll('[data-tr-checkout]:not([data-tr-init])').forEach(function (a) {
      a.setAttribute('data-tr-init', '1');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        trGoToCheckout();
      });
    });
  }

  /* Hero buy button/form → direct checkout permalink; never POSTs to the cart. */
  function initBuyForm(root) {
    (root || document).querySelectorAll('[data-tr-atc-form]:not([data-tr-buy-init])').forEach(function (form) {
      form.setAttribute('data-tr-buy-init', '1');
      var go = function (e) { e.preventDefault(); e.stopPropagation(); trGoToCheckout(); };
      // Cancel at the button click (capture) so the form submit is never generated,
      // and guard the submit event too (Enter / programmatic) — both bypass the
      // native <product-form-component> handler that would add to the cart.
      var btn = form.querySelector('[data-tr-atc]');
      if (btn) btn.addEventListener('click', go, true);
      form.addEventListener('submit', go);
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Boot                                                                    */
  /* ---------------------------------------------------------------------- */
  function boot(root) {
    initReveal(root);
    initCountdown(root);
    initCutoff(root);
    initCounters(root);
    initTimeline(root);
    initGallery(root);
    initHeroParallax();
    initBeforeAfter(root);
    initReviews(root);
    initMarquee(root);
    initPacks(root);
    initGifts(root);
    initFlips(root);
    initModals(root);
    initStickyBuy(root);
    initBuyForm(root);
    initCheckoutCtas(root);
    initStickyReveal(root);
    initProgress();
    initExit();
  }
  TR.boot = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Refresh cart badge after any native add-to-cart / cart update
  ['cart:update', 'cart:add', 'variant:add', 'on:cart:add'].forEach(function (evt) {
    document.addEventListener(evt, refreshCartCount);
  });
  document.addEventListener('DOMContentLoaded', refreshCartCount);

  // Theme editor: re-init when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); refreshCartCount(); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
